<script setup>
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import LaisGamificationSurface from 'dashboard/components-next/LaisGamificationSurface.vue';
import LaisHeader from 'dashboard/components-next/LaisHeader.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import SalesPropertyLookup from '../components/SalesPropertyLookup.vue';
import SalesPropertyOnusUpload from '../components/SalesPropertyOnusUpload.vue';
import SalesPropertyPreview from '../components/SalesPropertyPreview.vue';
import SalesCreationFooter from '../components/SalesCreationFooter.vue';
import { useSalesCreation } from '../composables/useSalesCreation';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const currentUser = useMapGetter('getCurrentUser');
const creation = useSalesCreation({
  route,
  router,
  t,
  notify: useAlert,
});

const goBack = () =>
  router.push({
    name: 'operacao_imobiliaria_vendas',
    params: { accountId: route.params.accountId },
  });
</script>

<template>
  <LaisGamificationSurface
    :user-id="currentUser?.id"
    show-rail
    class="min-h-full bg-lais-bg-soft"
  >
    <LaisHeader
      :title="t('SALES.CREATE.TITLE')"
      :subtitle="t('SALES.CREATE.SUBTITLE')"
      :breadcrumb="[
        { label: t('SALES.TITLE') },
        { label: t('SALES.CREATE.TITLE') },
      ]"
      show-back
      :back-label="t('SALES.ACTIONS.BACK')"
      @back="goBack"
    >
      <template #actions>
        <LaisPrimaryButton
          variant="ghost"
          icon="i-lucide-arrow-left"
          @click="goBack"
        >
          {{ t('SALES.ACTIONS.BACK') }}
        </LaisPrimaryButton>
      </template>
    </LaisHeader>

    <main
      class="mx-auto flex w-full max-w-[1100px] flex-col gap-5 px-4 pb-8 sm:px-6 lg:px-10"
    >
      <SalesPropertyLookup
        :code="creation.code.value"
        :error="creation.error.value"
        :loading="creation.loading.value"
        :success="creation.canConfirm.value"
        @search="creation.search(creation.code.value)"
        @update:code="creation.updateCode($event)"
      />
      <SalesPropertyOnusUpload
        :enabled="creation.onusEnabled.value"
        :file="creation.onusFile.value"
        :processing="creation.onusProcessing.value"
        @update:enabled="creation.setOnusEnabled"
        @update:file="creation.setOnusFile"
      />
      <SalesPropertyPreview
        :property="creation.property.value"
        :listing="creation.listing.value"
        @confirm="creation.create"
      />
    </main>
    <SalesCreationFooter
      :disabled="!creation.canConfirm.value || creation.onusProcessing.value"
      :loading="creation.creating.value"
      :message="creation.onusAnalysisMessage.value"
      :progress="creation.onusAnalysisProgress.value"
      :status="creation.onusAnalysisStatus.value"
      @confirm="creation.create"
    />
  </LaisGamificationSurface>
</template>
